import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "resellerView",
    "planImports",
    "granularPermissions",
    "actionView",
    "budget",
  ];

  connect() {
    this.disableReadOnlyCheckbox();
    this.updateBudgetAvailability();
  }

  updateCheckboxStates(event) {
    if (event.target == this.resellerViewTarget) {
      this.granularPermissionsTarget.disabled = this.resellerViewTarget.checked;
      this.granularPermissionsTarget.checked = false;
      this.planImportsTarget.disabled = this.resellerViewTarget.checked;
      this.planImportsTarget.checked = true;
    }

    if (event.target == this.granularPermissionsTarget) {
      this.resellerViewTarget.disabled = this.granularPermissionsTarget.checked;
      this.resellerViewTarget.checked = false;
    }

    if (
      event.target == this.actionViewTarget ||
      event.target == this.resellerViewTarget
    ) {
      this.budgetTarget.checked = this.budgetAvailable;
      this.updateBudgetAvailability();
    }
  }

  updateBudgetAvailability() {
    this.budgetTarget.disabled = !this.budgetAvailable;
  }

  get budgetAvailable() {
    return this.actionViewTarget.checked && !this.resellerViewTarget.checked;
  }

  disableReadOnlyCheckbox() {
    this.granularPermissionsTarget.disabled = this.resellerViewTarget.checked;
    this.resellerViewTarget.disabled = this.granularPermissionsTarget.checked;
    this.planImportsTarget.disabled = this.resellerViewTarget.checked;
    this.planImportsTarget.checked =
      this.resellerViewTarget.checked || this.planImportsTarget.checked;
  }
}
